<template>
    <div class="DashboardEditSection" :class="{requiresUpgrade}" :id="id">
        <Row>
            <Column class="titleColumn" :lg="3">
                <h3>{{ title }}</h3>
            </Column>

            <Column :lg="9">
                <Card>
                    <Banner
                        v-if="requiresUpgrade"
                        variant="info"
                        isSlim
                    >
                        This feature is not available in your plan. <router-link to="/company/billing" class="link primary">Upgrade now</router-link>
                    </Banner>
                    <div class="content">
                        <slot></slot>
                        <div v-if="requiresUpgrade" class="requiresUpgradeOverlay"></div>
                    </div>
                </Card>
            </Column>
        </Row>
    </div>
</template>

<script>
import Card from '@/components/Card';

export default {
    name: 'DashboardEditSection',

    components: { Card },

    props: {
        id: { type: String, required: false },
        title: { type: String, required: true },
        requiresUpgrade: { type: Boolean, default: false },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.DashboardEditSection {
    & + & {
        margin-top: 30px;
    }

    &.requiresUpgrade {
        .Card.content {
            pointer-events: none;
        }
    }

    .requiresUpgradeOverlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(#fff, 0.8);
    }

    .Card {
        width: 100%;

        .content {
            position: relative;
        }
    }


    .titleColumn {
        margin-top: 10px;
    }

    .Banner {
        margin-bottom: 30px;
    }

    @include breakpoint(md) {
        .titleColumn {
            margin: 10px;
        }
    }

    // Subtitles within section
    ::v-deep h2 {
        margin-bottom: $grid-gutter-width;
        font-weight: $font-weight-regular;
    }
}
</style>
